var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmonstrSmartphone71(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.02 7.389C10.419 7.104 10.87 6.972 11.312 6.972C12.256 6.972 13.164 7.572 13.462 8.571C13.08 8.277 12.632 8.134 12.181 8.134C11.723 8.134 11.262 8.281 10.86 8.568C10.061 9.138 9.707 10.109 10.015 11.029C8.773 10.139 8.768 8.282 10.02 7.389ZM13.761 20.159C14.755 20.493 17.832 21.345 21.396 24L28 19.29C26.287 16.888 26.759 15.208 25.057 12.822C23.895 11.194 23.23 11.168 22.02 11.39L22.619 12.23C22.98 12.737 22.214 13.28 21.855 12.774L21.321 12.024C20.886 11.415 20.042 11.795 19.268 11.973L19.995 12.992C20.355 13.497 19.592 14.043 19.231 13.536L18.602 12.654C18.156 12.028 17.284 12.446 16.507 12.644L17.276 13.722C17.639 14.23 16.871 14.771 16.512 14.266L13.394 9.9C12.426 8.542 10.306 9.983 11.308 11.389L15.913 17.847C15.419 17.664 14.55 17.498 13.983 17.498C12.229 17.498 11.554 19.418 13.761 20.159ZM10.475 18H6V4H16V10.688L18 10.217V2C18 0.896 17.105 0 16 0H6C4.895 0 4 0.896 4 2V20.678C3.999 22.891 7.503 24 11.005 24C12.817 24 14.624 23.701 15.949 23.106C13.828 22.16 9.571 21.53 10.475 18Z",
    fill: "#00642B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrSmartphone71);
export default __webpack_public_path__ + "static/media/iconmonstr-smartphone-7 1.22e65e7da1ae580a60d09bf02d9b3ce7.svg";
export { ForwardRef as ReactComponent };